<section [class.py-12]="data.hasGrayBackground" class="w-screen">
  @let containerClass = data.hasGrayBackground ? "bg-gray-light pb-16 pt-14 desk:pb-24 desk:pt-20 mask-curve-top" : "";
  <div [class]="containerClass" class="py-8">
    <div class="desk:centered-with-padding">
      <div class="mb-5 px-5 desk:mb-8 desk:px-0">
        <app-title [title]="{ text: data.title, as: 'span' }" size="h2" />
      </div>

      <div class="no-scrollbar flex gap-x-4 overflow-x-scroll px-5 desk:grid desk:grid-cols-3 desk:gap-x-5 desk:px-0">
        @for (stickerPairText of data.stickerPairTexts; track $index) {
          <div class="flex shrink-0 p-3 desk:w-full">
            @for (text of stickerPairText; track $index; let i = $index) {
              @let firstStickerClass = "rotate-[-6.5deg] z-10 font-title text-[65px] leading-[56px]";
              @let secondStickerClass = "bg-anis rotate-[1.5deg] font-title-alt text-[23px] leading-[25px]";
              <div
                class="flex h-[160px] w-[135px] items-center justify-center rounded-[35px] p-1 text-center"
                [class.bg-blue]="i === 0 && data.firstStickersColor === 'blue'"
                [class.bg-yellow]="i === 0 && data.firstStickersColor === 'yellow'"
                [class.bg-purple]="i === 0 && data.firstStickersColor === 'purple'"
                [class]="i === 0 ? firstStickerClass : secondStickerClass">
                {{ text }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  @if (data.hasGrayBackground) {
    <div class="mask-curve-top w-full bg-white py-7"></div>
  }
</section>
